import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';

export default function DialogUpdateDateAdmin({ open, handleClose, currentDate, onConfirm }) {
  const [selectedDate, setSelectedDate] = useState(dayjs(currentDate));

  const handleConfirm = () => {
    onConfirm(selectedDate.toDate());
  };

  return (
    <Dialog open={open} onClose={() => handleClose(false)}>
      <DialogTitle>Modifier la date de l'EDL</DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
          <DateTimePicker
            label="Nouvelle date et heure"
            value={selectedDate}
            onChange={(newValue) => setSelectedDate(newValue)}
            ampm={false}
            minutesStep={15}
            slotProps={{
              textField: {
                fullWidth: true,
                sx: { mt: 1 },
              },
            }}
          />
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)} color="error" variant="outlined">
          Annuler
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  );
}
